import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { v4 as uuid } from "uuid"
import "../index.css"

import { TextInputField, AutoCompleteField, Button, CalendarField, DropDownField } from '../../../helpers'
import { Toast } from 'primereact/toast'
import { FileUpload } from 'primereact/fileupload'

import { validateInputs, convertURLToDataURI } from '../../../utils'
import Loading from '../../../common/Loading'

import { BuyerRateContractValidation } from '../../../validation/buyerRateContractValidation'

import { raiseToast } from '../../../services/redux/reducers/toast/toast'


const EditRateContractProduct = (props) => {
    const dispatch = useDispatch()
    const {
        editRateContractObj,
        HSNMasterData,
        companyGSTRateData,
        companyDetails,
        initialRateContractObj
    } = props

    const [existingCompanyERPCodeMapObj, setExistingCompanyERPCodeMapObj] = useState(null)
    const [GSTRates, setGSTRates] = useState([])
    const [isCompanyERPCodeExists, setIsCompanyERPCodeExists] = useState(false)
    const [searchedCompanyBranches, setSearchedCompanyBranches] = useState([])
    const [formErrors, setFormErrors] = useState({})
    const [materialImages, setMaterialImages] = useState([])
    const [imageURL, setImageURL] = useState('')
    const [isLoaderVisible, setIsLoaderVisible] = useState(false)
    const [isTempMaterialId, setIsTempMaterialId] = useState(false)
    
    useEffect(() => {
        if (props.editRateContractObj) {
            if (props.editRateContractObj.companyERPCode) {
                setIsCompanyERPCodeExists(true)
            }

            if (props.editRateContractObj.companyHSNOverride) {
                let relatedGSTRates = HSNMasterData?.filter(eachHSN => eachHSN?.HSNCode === props.editRateContractObj.companyHSNOverride)
                if (relatedGSTRates && relatedGSTRates.length > 0) {
                    let updatedGSTRates = relatedGSTRates?.map(eachGSTRate => {
                        if (eachGSTRate.GSTRate === 0) {
                            return ({ ...eachGSTRate, GSTRate: '0' })
                        }
                        return eachGSTRate
                    })

                    setGSTRates([...updatedGSTRates])
                } else {
                    let updatedCompanyGSTRate = companyGSTRateData?.map(eachGSTRate => {
                        if (eachGSTRate.GSTRate === 0) {
                            return ({ ...eachGSTRate, GSTRate: '0' })
                        }
                        return eachGSTRate
                    })

                    setGSTRates([...updatedCompanyGSTRate])
                }
            }
        }
    }, [companyGSTRateData])

    useEffect(() => {
        const fetchMaterialImages = async () => {
            if (editRateContractObj.companyERPCodeMap) {
                setIsLoaderVisible(true)
                let {materialMaster, materialMasterTemp} = editRateContractObj.companyERPCodeMap
                let allMaterialImages = []
                if(materialMaster && materialMaster.materialImage?.length){
                    allMaterialImages = [...materialMaster.materialImage]
                }else if(materialMasterTemp && materialMasterTemp.materialImage?.length){
                    allMaterialImages = [...materialMasterTemp.materialImage]
                }
                if(allMaterialImages.length){
                    const formattedMaterialImages = await Promise.all(allMaterialImages.map(async eachImage => {
                        let imageObj = {
                            file: null,
                            fileName: "BUYER_RATE_CONTRACT",
                            url: eachImage,
                            dataURI: await convertURLToDataURI(eachImage),
                            documentName: "BUYER_RATE_CONTRACT",
                            isOld: true,
                            imageId: uuid()
                        }
                        return imageObj
                    }))
    
                    setMaterialImages(prevState => [...prevState, ...formattedMaterialImages])
                }
                setIsLoaderVisible(false)
            }
        }

        if (editRateContractObj) {
            fetchMaterialImages()
        }
    }, [])

    useEffect(() => {
        if (editRateContractObj.materialId && editRateContractObj.materialId.toString().length >= 7) {
            setIsTempMaterialId(true)
        }
    }, [editRateContractObj.materialId])

    const searchCompanyBranches = (event) => {
        const relatedCompanyBranches = props.companyBranches.filter(branch => branch.branchName.toLowerCase().includes(event.query.trim().toLowerCase()))
        setSearchedCompanyBranches([...relatedCompanyBranches])
    }

    const handleInputChange = (event) => {
        editRateContractObj[event.target.name] = event.target.value

        let relatedCompanyERPCodeMap = existingCompanyERPCodeMapObj

        if (event.target.value != null) {
            if (event.target.name === "companyERPCode") {
                if (typeof (event.target.value) === "object") {
                    relatedCompanyERPCodeMap = props.companyERPCodeMapData.find(eachERPCode => eachERPCode?.companyERPCode?.toLowerCase() === event.target.value.companyERPCode?.trim()?.toLowerCase())
                }
                else {
                    relatedCompanyERPCodeMap = props.companyERPCodeMapData.find(eachERPCode => eachERPCode?.companyERPCode?.toLowerCase() === event.target.value?.trim().toLowerCase())
                }

                if (relatedCompanyERPCodeMap) {
                    setExistingCompanyERPCodeMapObj(relatedCompanyERPCodeMap)

                    editRateContractObj.materialId = relatedCompanyERPCodeMap.materialId
                    editRateContractObj.companyProdName = relatedCompanyERPCodeMap.companyProdName
                    editRateContractObj.companyProdSpec = relatedCompanyERPCodeMap.companyProdSpec
                    editRateContractObj.companyERPCategory = relatedCompanyERPCodeMap.companyERPCategory
                    editRateContractObj.companyERPUOM = relatedCompanyERPCodeMap.companyERPUOM
                    editRateContractObj.companyHSNOverride = relatedCompanyERPCodeMap.companyHSNOverride
                    editRateContractObj.companyGSTOverride = relatedCompanyERPCodeMap.companyGSTOverride
                    editRateContractObj.UNSPSC = relatedCompanyERPCodeMap.UNSPSC
                }
                else {
                    setExistingCompanyERPCodeMapObj(null)
                }
            }

            if (event.target.name === "companyHSNOverride") {
                let relatedGSTRates = HSNMasterData?.filter(eachHSN => eachHSN?.HSNCode == event.target.value)
                if (relatedGSTRates && relatedGSTRates.length > 0) {

                    let updatedGSTRates = relatedGSTRates?.map(eachGSTRate => {
                        if (eachGSTRate.GSTRate === 0) {
                            return ({ ...eachGSTRate, GSTRate: '0' })
                        }
                        return eachGSTRate
                    })
                    if (updatedGSTRates.length === 1) {
                        editRateContractObj["companyGSTOverride"] = updatedGSTRates[0].GSTRate
                    }
                    setGSTRates([...updatedGSTRates])
                } else {
                    let updatedCompanyGSTRate = companyGSTRateData?.map(eachGSTRate => {
                        if (eachGSTRate.GSTRate === 0) {
                            return ({ ...eachGSTRate, GSTRate: '0' })
                        }
                        return eachGSTRate
                    })

                    setGSTRates([...updatedCompanyGSTRate])
                    editRateContractObj["companyGSTOverride"] = ''
                }
            }
        }

        if (props.companyId && event.target.name === "companyERPCode" && event.target.name === "materialId" && event.target.name === "branchId") {
            if (relatedCompanyERPCodeMap && props.companyId && editRateContractObj.materialId && editRateContractObj.branchId) {
                let rateContractParams = {
                    companyId: props.companyId,
                    companyERPCodeMapId: relatedCompanyERPCodeMap.companyERPCodeMapId,
                    materialId: editRateContractObj.materialId,
                    branchId: editRateContractObj.branchId
                }

                if (typeof (editRateContractObj.branchId) === 'object') {
                    rateContractParams.branchId = editRateContractObj.branchId.branchId
                } else {
                    rateContractParams.branchId = editRateContractObj.branchId
                }

                props.getExistingRateContractDataByValues(rateContractParams)
            }
        }

        props.setEditRateContractObj({ ...editRateContractObj })
    }

    const handleOnSubmitBuyerRateContract = async () => {
        let validationRCInputsObj = { ...editRateContractObj }
        if (validationRCInputsObj.branchId && typeof (validationRCInputsObj.branchId) === 'object') {
            validationRCInputsObj.branchId = validationRCInputsObj.branchId.branchId
        } else {
            validationRCInputsObj.branchId = validationRCInputsObj.branchId
        }

        if (validationRCInputsObj.companyERPCode && typeof (validationRCInputsObj.companyERPCode) === 'object') {
            validationRCInputsObj.companyERPCode = validationRCInputsObj.companyERPCode.companyERPCode
        } else {
            validationRCInputsObj.companyERPCode = validationRCInputsObj.companyERPCode ? validationRCInputsObj.companyERPCode : ""
        }

        if (companyDetails.meplatoCatalogId) {
            validationRCInputsObj.meplatoCatalogId = companyDetails.meplatoCatalogId
            validationRCInputsObj.VATCode = validationRCInputsObj?.VATCode?.trim()
            if (!validationRCInputsObj.VATCode) {
                return dispatch(raiseToast({ severity: 'warn', detail: "Please enter VAT code", life: 3000 }))
            }

            validationRCInputsObj.UNSPSC = validationRCInputsObj?.UNSPSC?.trim()
            if (!validationRCInputsObj.UNSPSC) {
                return dispatch(raiseToast({ severity: 'warn', detail: "Please enter UNSPSC", life: 3000 }))
            }
        }

        if (companyDetails.tags?.isERPCodeMandatory){
            if (!validationRCInputsObj.companyERPCode){
                return dispatch(raiseToast({ severity: 'warn', detail: "Please enter Company ERP Code.", life: 3000 }))
            }
        }
        
        const validationResponse = await validateInputs(BuyerRateContractValidation, validationRCInputsObj)
        console.log("validation-Response", validationResponse)
        if (validationResponse) {
            if (validationResponse.error) {
                setFormErrors(validationResponse.error)
                Object.keys(validationResponse.error).map(eachError => {
                    dispatch(raiseToast({ severity: 'warn', detail: validationResponse.error[eachError], life: 3000 }))
                })
            }
            else {
                setFormErrors({})
                props.updateBuyerRCData({...validationResponse.result, materialImages})
            }
        }
    }

    const handleImageURLChange = (event) => {
        if (materialImages.length >= 5) {
            setImageURL('')
            return dispatch(raiseToast({ severity: 'warn', summary: 'Warning Message', detail: "Maximum upload images should be 5 only", life: 3000 }))
        }
        setImageURL(event.target.value)
    }

    const handleImageUrl = async (imageUrl) => {

        if (imageUrl) {
            imageUrl = imageUrl.trim()
        }

        if (!imageUrl || imageUrl === '') {
            return dispatch(raiseToast({ severity: 'warn', summary: 'Warning Message', detail: "Please enter proper url", life: 3000 }))
        }
        const validExtensions = ['.jpg', '.png', '.jpeg']
        if (!validExtensions.some((ext) => imageUrl.endsWith(ext))) {
            return dispatch(raiseToast({ severity: 'warn', summary: 'Warning Message', detail: "Please enter valid extension url file", life: 3000 }))
        }

        const response = await fetch(imageUrl)
        const blob = await response.blob()
        const reader = new FileReader()

        reader.onload = () => {
            const base64Data = reader.result

            let relatedMaterialImage = materialImages.find(eachImage => eachImage.dataURI === base64Data)
            if (relatedMaterialImage) {
                return dispatch(raiseToast({ severity: 'error', detail: "The uploaded image already added", life: 3000 }))
            }

            const url = URL.createObjectURL(blob)

            const urlParts = imageUrl.split('/')
            const filePart = urlParts[urlParts.length - 1]

            let imageURLObj = {
                url: url,
                documentName: "BUYER_RATE_CONTRACT",
                fileName: filePart,
                dataURI: base64Data,
                imageId: uuid()
            }
            setMaterialImages(prevImages => [...prevImages, imageURLObj])
            setImageURL('')
        }

        reader.readAsDataURL(blob)
    }

    const handleUploadMaterialImage = async ({ files, options }) => {
        const filesArray = Array.from(files)
        if (files.length > 5 || (materialImages.length + files.length) > 5) {
            options.clear()
            return dispatch(raiseToast({ severity: 'warn', summary: 'Warning Message', detail: "Maximum upload images should be 3 only", life: 3000 }))
        }

        let uploadImages = []
        let imageURIs = []
        await Promise.all(
            filesArray.map((file) => new Promise((resolve) => {
                if (file.size > 5242880) {
                    options.clear()
                    return dispatch(raiseToast({ severity: 'error', summary: "Upload File", detail: 'File size exceeds 5MB', life: 3000 }))
                } else {
                    const fileReader = new FileReader()
                    fileReader.onload = (e) => {
                        const dataURI = e.target.result
                        uploadImages.push({
                            url: file.objectURL,
                            documentName: "BUYER_RATE_CONTRACT",
                            fileName: file.name,
                            dataURI: dataURI,
                            imageId: uuid()
                        })
                        imageURIs.push(dataURI)
                        resolve()
                    }

                    fileReader.readAsDataURL(file)
                }
            }))
        )
        options.clear()

        let isMaterialImageAlreadyExists = materialImages.some(eachImage => imageURIs.includes(eachImage.dataURI))
        if (isMaterialImageAlreadyExists) {
            return dispatch(raiseToast({ severity: 'error', detail: "The uploaded image already added", life: 3000 }))
        }

        setMaterialImages(prevImages => [...prevImages, ...uploadImages])
    }

    const handleRemoveMaterialImage = (removedImageId) => {
        const relatedImages = materialImages.filter(image => removedImageId !== image.imageId)
        setMaterialImages([...relatedImages])
    }

    return (
        <div className="">
            <Toast ref={Toast} />
            <div className="grid">
                <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                    <AutoCompleteField name="branchId" labelText="Company Branch" field="branchName" placeholder="Select Branch" value={editRateContractObj.branchId} suggestions={searchedCompanyBranches} searchMethod={searchCompanyBranches} onChange={(e) => handleInputChange(e)} dropdown forceSelection errorMessage={formErrors.branchId} disabled />
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                    <TextInputField name="companyERPCode" labelText="Company ERPCode" placeholder="ERPCode" value={editRateContractObj.companyERPCode} onChange={(e) => handleInputChange(e)} errorMessage={formErrors.companyERPCode} disabled={isCompanyERPCodeExists} />
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                    <TextInputField name="materialId" labelText="PM MaterialId" placeholder="MaterialId" keyfilter={"pint"} value={editRateContractObj.materialId} onChange={(e) => handleInputChange(e)} errorMessage={formErrors.materialId} disabled />
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                    <TextInputField name="companyProdName" labelText="Company Product Name" placeholder="Product Name" value={editRateContractObj.companyProdName} onChange={(e) => handleInputChange(e)} errorMessage={formErrors.companyProdName} />
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                    <TextInputField name="companyProdSpec" labelText="Company Prod Specification" placeholder="Specification" value={editRateContractObj.companyProdSpec} onChange={(e) => handleInputChange(e)} errorMessage={formErrors.companyProdSpec} />
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                    <TextInputField name="companyERPCategory" labelText="Company ERP Category" placeholder="ERP Category" value={editRateContractObj.companyERPCategory} onChange={(e) => handleInputChange(e)} errorMessage={formErrors.companyERPCategory} />
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                    <TextInputField name="companyERPUOM" labelText="Company ERP UOM" placeholder="UOM" value={editRateContractObj.companyERPUOM} onChange={(e) => handleInputChange(e)} errorMessage={formErrors.companyERPUOM} />
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                    <TextInputField name="companyHSNOverride" labelText="HSNCode" placeholder="HSN" value={editRateContractObj.companyHSNOverride} keyfilter={"pint"} onChange={(e) => handleInputChange(e)} errorMessage={formErrors.companyHSNOverride} />
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                    <DropDownField
                        name="companyGSTOverride"
                        labelText='GSTRate'
                        placeholder="GSTRate"
                        value={editRateContractObj.companyGSTOverride}
                        options={GSTRates}
                        optionLabel="GSTRate"
                        optionValue="GSTRate"
                        keyfilter="pint"
                        onChange={(e) => handleInputChange(e)}
                        errorMessage={formErrors.companyGSTOverride}
                    />
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                    <TextInputField name="UNSPSC" labelText="UNSPSC" placeholder="UNSPSC" value={editRateContractObj.UNSPSC} onChange={(e) => handleInputChange(e)} errorMessage={formErrors.UNSPSC} />
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                    <TextInputField name="unitPrice" labelText="Unit Price" placeholder="Unit Price" keyfilter={"pnum"} value={editRateContractObj.unitPrice} onChange={(e) => handleInputChange(e)} errorMessage={formErrors.unitPrice} />
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                    <TextInputField name="leadTime" labelText="Lead Time (In days)" placeholder="Lead Time" keyfilter={"pint"} value={editRateContractObj.leadTime} onChange={(e) => handleInputChange(e)} errorMessage={formErrors.leadTime} />
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                    <CalendarField
                        name="validityPeriod"
                        labelText="Validity Date"
                        placeholder=""
                        value={editRateContractObj.validityPeriod ? new Date(editRateContractObj.validityPeriod) : null}
                        minDate={new Date()}
                        maxDate={props.maxValidityPeriod}
                        onChange={(e) => handleInputChange(e)}
                        errorMessage={formErrors.validityPeriod}
                    />
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                    <TextInputField name="companyQtyMultiplier" keyfilter={"pnum"} labelText="Qty Multiple" placeholder="Qty Multiple" value={editRateContractObj.companyQtyMultiplier} onChange={(e) => handleInputChange(e)} errorMessage={formErrors.companyQtyMultiplier} />
                </div>
                {
                    companyDetails.meplatoCatalogId ?
                        <>
                            <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                                <TextInputField name="VATCode" labelText="Vat Code" placeholder="VAT Code" value={editRateContractObj.VATCode} onChange={(e) => handleInputChange(e)} errorMessage={formErrors.VATCode} />
                            </div>
                            <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                                <TextInputField name="minOrderQty" labelText="Min Order Qty" placeholder="Min Qty" value={editRateContractObj.minOrderQty} onChange={(e) => handleInputChange(e)} keyfilter="pnum" />
                            </div>
                        </>
                        : ""
                }
                <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                    <TextInputField name="make" labelText="Make" placeholder="Make" value={editRateContractObj.make} onChange={(e) => handleInputChange(e)} />
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                    <TextInputField name="partNo" labelText="Part No." placeholder="Part No." value={editRateContractObj.partNo} onChange={(e) => handleInputChange(e)} />
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                    <TextInputField name="monthlyQty" labelText="MonthlyQty" placeholder="Monthly Qty" value={editRateContractObj.monthlyQty} keyfilter={"pnum"} onChange={(e) => handleInputChange(e)} errorMessage={formErrors.monthlyQty} disabled={initialRateContractObj.monthlyQty}/>
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                    <TextInputField name="monthlyValue" labelText="MonthlyValue" placeholder="Monthly Value" value={editRateContractObj.monthlyValue} keyfilter={"pnum"} onChange={(e) => handleInputChange(e)} errorMessage={formErrors.monthlyValue} disabled={initialRateContractObj.monthlyValue}/>
                </div>
            </div>
            <div className="flex flex-column col-12 align-items-start">
                {materialImages.length > 0 && <h4 className="mt-0 ml-2 mb-2">Material Images</h4>}
                <div className='' style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '0.5rem' }}>
                    {
                        materialImages.length > 0 ? materialImages.map(image => {
                            return (
                                <div key={image.imageId} className='prod-image-container'>
                                    <div className=''>
                                        <img
                                            src={image.dataURI}
                                            alt="Preview"
                                            className="prod-image"
                                            style={{ border: '1px solid #ccc', boxShadow: 'none', borderRadius: "3px", objectFit: 'cover' }}
                                        />
                                        {
                                            isTempMaterialId || !image.isOld ? <i className="pi pi-times prod-remove-icon" onClick={() => handleRemoveMaterialImage(image.imageId)}></i> : null
                                        }
                                    </div>
                                </div>
                            )
                        }) : ""
                    }
                </div>
            </div>
            {
                materialImages.length < 5 && editRateContractObj.materialId && (
                    <div className="flex col-3 pl-0 pt-0 col-12 lg:mb-0">
                        <div className="flex flex-column col-12 mb-2 md:col-8 lg:col-9 lg:mb-0 md:pl-0">
                            <TextInputField name="imageURL" labelText="Image URL" value={imageURL} onChange={(e) => handleImageURLChange(e)} />
                        </div>
                        {
                            imageURL?.trim() ?
                                <div className='mt-3 flex col-12 mb-2 md:col-4 lg:col-3 lg:mb-0'>
                                    <Button className="small-btn" label="Add Image URL" onClick={() => handleImageUrl(imageURL)} />
                                </div>
                                :
                                <div className="flex flex-column col-12 md:col-4 lg:col-3 mt-3">
                                    <FileUpload mode="basic" name="materialImage" accept="image/*" customUpload auto multiple chooseLabel="Upload Image" uploadHandler={(files) => handleUploadMaterialImage(files)} />
                                </div>
                        }
                    </div>
                )
            }
            <div className='mt-3 flex justify-content-end'>
                <Button className="mr-3" severity="danger" label={"Delete"} onClick={() => props.deleteBuyerRateContract(editRateContractObj.buyerRateContractId)} />
                <Button label={"Update"} onClick={() => handleOnSubmitBuyerRateContract()} permissions={[158]}/>
            </div>
            <Loading visible={isLoaderVisible} />
        </div>
    )
}

export default EditRateContractProduct